import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    list: [],
    selectList: [],

    listPersonales: [],
    selectListPersonales: [],

    listFiscales: [],
    selectListFiscales: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(item => item.nombre.trim());
    },

    'INICIALIZAR_LIST_PERSONALES'(state) {
        state.listPersonales = [];
        state.selectListPersonales = [];
    },
    'SET_LIST_PERSONALES'(state, list) {
        state.listPersonales = list;
        state.selectListPersonales = list.map(item => item.nombre.trim());
    },

    'INICIALIZAR_LIST_FISCALES'(state) {
        state.listFiscales = [];
        state.selectListFiscales = [];
    },
    'SET_LIST_FISCALES'(state, list) {
        state.listFiscales = list;
        state.selectListFiscales = list.map(item => item.nombre.trim());
    },
};

const actions = {
    getList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('documentostipos/list')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    getListPersonales: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST_PERSONALES');

            apiAxios.get('documentostipos/personales')
                .then(res => {
                    commit('SET_LIST_PERSONALES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    getListFiscales: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST_FISCALES');

            apiAxios.get('documentostipos/fiscales')
                .then(res => {
                    commit('SET_LIST_FISCALES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },

};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
    listPersonales (state) {
        return state.listPersonales;
    },
    selectListPersonales (state) {
        return state.selectListPersonales;
    },
    listFiscales (state) {
        return state.listFiscales;
    },
    selectListFiscales (state) {
        return state.selectListFiscales;
    },        
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}